import * as React from 'react';
import Stack from '@mui/material/Stack';
import { styled, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

import { AppRoutes } from 'config';

import { Link } from '../shared/Link';
import { type Branding } from '../AppProvider';
import { useApplicationTitle } from '../shared/branding';

import { ToolpadLogo } from './ToolpadLogo';

const LogoContainer = styled('div')({
  height: 40,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  '& img': {
    maxHeight: 40,
  },
});

export interface AppTitleProps {
  branding?: Branding;
}

/**
 * @ignore - internal component.
 */
export function AppTitle(props: AppTitleProps) {
  const theme = useTheme();
  const defaultTitle = useApplicationTitle();
  const title = props?.branding?.title ?? defaultTitle;
  return (
    <Link
      style={{ textDecoration: 'none' }}
      href={props?.branding?.homeUrl ?? AppRoutes.Home}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <LogoContainer>
          {props?.branding?.logo ?? <ToolpadLogo size={40} />}
        </LogoContainer>
        <Typography
          variant="h6"
          sx={{
            ml: 1,
            lineHeight: 1,
            fontWeight: '700',
            whiteSpace: 'nowrap',
            color: (theme.vars ?? theme).palette.primary.main,
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Link>
  );
}
